// extracted by mini-css-extract-plugin
export default {"price_wrapper":"AdvertisementFullscreenImageBanner_price_wrapper__LRT6x","shimmer":"AdvertisementFullscreenImageBanner_shimmer__XlhvE"};